import { DELIVERY_TYPE, DINEIN_TYPE, PICKUP_TYPE } from '../webStorage/keys/sessionKeys';
import { getOrderType } from '../webStorage/manageOrderType';

export const getPrice = (item) => {
  if (!item) return;
  const orderType = getOrderType(false);

  return (
    (orderType == DINEIN_TYPE && item?.price) ||
    (orderType == DELIVERY_TYPE && item?.delivery_price) ||
    (orderType && item?.takeaway_price)
  );
};

export const getAllPrices = (item) => {
  const orderType = getOrderType(false);
  let priceCut, priceCutText, priceCutPercent, offeringPrice, offeringPriceText;
  if (orderType == DINEIN_TYPE) {
    offeringPrice = item.price;
    offeringPriceText = item.price_text;
  } else if (orderType == DELIVERY_TYPE) {
    offeringPrice = item.delivery_price;
    offeringPriceText = item.delivery_price_text;
  } else if (orderType == PICKUP_TYPE) {
    offeringPrice = item.takeaway_price;
    offeringPriceText = item.takeaway_price_text;
  }
  if (orderType == DINEIN_TYPE) {
    priceCut = item.price_pricecut;
    priceCutText = item.price_pricecut_text;
    priceCutPercent = item.price_pricecut_percent;
  } else if (orderType == DELIVERY_TYPE) {
    priceCut = item.delivery_pricecut;
    priceCutText = item.delivery_pricecut_text;
    priceCutPercent = item.delivery_pricecut_percent;
  } else if (orderType == PICKUP_TYPE) {
    priceCut = item.takeaway_pricecut;
    priceCutText = item.takeaway_pricecut_text;
    priceCutPercent = item.takeaway_pricecut_percent;
  }
  return {
    priceCut,
    priceCutText,
    priceCutPercent,
    offeringPrice,
    offeringPriceText,
  };
};
